import Guideline from "./Guideline";
import React, { useState } from "react";

function InputQuestion(props) {
  var isPercent = false;
  if (props.Unit === "percent") {
    isPercent = true;
  }
  const [curVal, setCurVal] = useState(
    props.Answer
    // isPercent
    //   ? props.Answer
    //   : Number(props.Answer.replace(/\D/g, "")).toLocaleString()
  );

  function formatNumber(number) {
    if (isNaN(number)) {
      return number;
    }
    if (isPercent) {
      return number;
    }
    return Number(number.replace(/\D/g, "")).toLocaleString();
  }

  function validateCurrency(e) {
    var x = e.target.value;
    var regex = /^[0-9]|\.|,+$/;
    if (!x.match(regex)) {
      e.target.value = "0";
    }
    //console.log(`${e.target.name} now says ${e.target.value}`);
  }

  function handleSelect(e) {
    const value = e.target.value;
    if (value === "0" || value === 0) {
      e.target.value = "";
    }
  }
  const handleChange = (name, event) => {
    const value = event.target.value.replace(/\D/g, "");

    if (isPercent === false) {
      if (value !== "") {
        const formattedValue = (
          Number(value.replace(/\D/g, "")) || ""
        ).toLocaleString();
        setCurVal(formattedValue.toString());
        event.target.value = formattedValue;
      }
    } else {
      setCurVal(value);
    }

    // console.log(value, "value");
    return null;
  };

  return (
    <li id={props.id + "_li"}>
      <label className="description" htmlFor={props.id}>
        {props.QuestionText}
      </label>
      <span className="symbol">{props.Symbol}</span>
      <span>
        <input
          id={props.id}
          name={props.id}
          className={"element text currency " + props.Section}
          onBlur={(event) => {
            validateCurrency(event);
            props.handleValue(event);
          }}
          onChange={(event) => {
            handleChange(props.id, event);
          }}
          onSelect={(event) => handleSelect(event)}
          defaultValue={formatNumber(curVal)}
          size="10"
          type="text"
        />
        {props.Post}
        <label htmlFor={props.id}>{props.Unit}</label>
      </span>
      {props.GuidelineText ? (
        <Guideline id={props.id}> {props.GuidelineText}</Guideline>
      ) : (
        <></>
      )}
    </li>
  );
}

export default InputQuestion;
